<template>
  <!-- Modal -->
  <div class="modal fade" id="editar_promocion_Modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar promocion</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="edit_instituciones">Instituciones:</label>
                <select class="form-control" id="edit_instituciones" v-model="promocion.institucion_id" @change="changeInstitucion" required>
                  <option value="" selected disabled hidden>Selecciona...</option>
                  <option v-for="i in instituciones" :key="i.id" :value="i.id">{{ i.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="edit_ciclo_escolar">Ciclo escolar</label>
                <select class="form-control" id="edit_ciclo_escolar" v-model="promocion.ciclo_escolar_id" required>
                  <option value="" selected disabled hidden>Selecciona...</option>
                  <option v-for="ce in ciclos_escolares" :key="ce.id" :value="ce.id">{{ ce.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" name="aplica" type="radio" id="editar_r_programa" value="programa" @change="aplicaChange" v-model="aplica">
                  <label class="form-check-label" for="editar_r_programa">Programa</label>
                </div>

                <select class="form-control" id="editar_programa" v-model="promocion.programa_id" :disabled="aplica != 'programa'">
                  <option value="" selected disabled hidden>Selecciona...</option>
                  <option v-for="p in programas" :key="p.id" :value="p.id">{{ p.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" name="aplica" type="radio" id="editar_r_nacademico" value="nacademico" @change="aplicaChange" v-model="aplica">
                  <label class="form-check-label" for="editar_r_nacademico">Nivel Académico</label>
                </div>

                <select class="form-control" id="editar_nivel_academico" v-model="promocion.nivel_academico_id" :disabled="aplica != 'nacademico'">
                  <option value="" selected disabled hidden>Selecciona...</option>
                  <option v-for="n in niveles_academicos" :key="n.id" :value="n.id">{{ n.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_metodo_descuento">Método de descuento</label>
                <select class="form-control" id="editar_metodo_descuento" v-model="promocion.metodo_descuento">
                  <option value="porcentaje">Porcentaje</option>
                  <option value="monto">Monto</option>
                </select>
              </div>
            </div>

            <div class="col-6">
                <div class="form-group" v-if="promocion.metodo_descuento == 'monto'">
                    <label for="editar_monto">Monto *</label>
                    <input type="number" class="form-control" name="monto" id="editar_monto" v-model="promocion.monto" placeholder="0" autocomplete="off">
                </div>

                <div class="form-group" v-if="promocion.metodo_descuento == 'porcentaje'">
                    <label for="editar_procentaje">Porcentaje *</label>
                    <input type="number" class="form-control" name="porcentaje" id="editar_procentaje" v-model="promocion.porcentaje" placeholder="0" autocomplete="off">
                </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_fecha_apertura">Fecha de apertura</label>
                <input type="date" class="form-control" id="editar_fecha_apertura" v-model="promocion.fecha_apertura" />
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_fecha_cierre">Fecha de cierre</label>
                <input type="date" class="form-control" id="editar_fecha_cierre" v-model="promocion.fecha_cierre" />
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_codigo_detalle_abono_id">Abono</label>
                <select class="form-control" id="editar_codigo_detalle_abono_id" v-model="promocion.codigo_detalle_abono_id" required>
                  <option v-for="d in descuentos" :key="d.id" :value="d.id">{{ d.text }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <div class="form-group">
                <label for="editar_codigo_detalle_cargo_id">Cargo</label>
                <select class="form-control" id="editar_codigo_detalle_cargo_id" v-model="promocion.codigo_detalle_cargo_id" required>
                  <option v-for="c in cargos" :key="c.id" :value="c.id">{{ c.text }}</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="save">Guardar y cerrar</button>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import Axios from 'axios';

export default {
  props: [ 'promocionId' ],
  data() {
    return {
      instituciones: [],
      ciclos_escolares: [],
      descuentos: [],
      cargos: [],
      programas: [],
      aplica: '',
      promocion: {
        "id": 0,
        "ciclo_escolar_id": 0,
        "institucion_id": 0,
        "programa_id": 0,
        "nivel_academico_id": null,
        "codigo_detalle_cargo_id": 0,
        "codigo_detalle_abono_id": 0,
        "metodo_descuento": "",
        "porcentaje": null,
        "monto": 0,
        "fecha_apertura": "2021-03-01",
        "fecha_cierre":"2021-03-10",
        "acumulativo": '',
        "created_at":"",
        "updated_at":""
      }
    }
  },
  async created() {
    this.instituciones = await Axios.get('/instituciones/usuario').then(resp => resp.data);
    this.descuentos = await Axios.get('/codigos-de-detalle/descuentos').then(resp => resp.data);
    this.cargos = await Axios.get('/codigos-de-detalle/cargos').then(resp => resp.data);

    $('#editar_promocion_Modal').on('show.bs.modal', async () => {
      await this.load();
    });
  },
  methods: {
    async changeInstitucion() {
      this.ciclos_escolares = await Axios.get(`/ciclos-escolares/ciclosPorInstitucion/${this.promocion.institucion_id}`).then(resp => resp.data);
      this.programas = await Axios.get(`/programas/institucion/${this.promocion.institucion_id}`).then(resp => resp.data);
      this.niveles_academicos = await Axios.get(`/niveles-academicos/filtrar?institucion_id=${this.promocion.institucion_id}`).then(resp => resp.data);
    },
    aplicaChange() {
      if (this.aplica == 'programa') {
        this.promocion.nivel_academico_id = '';
      } else {
        this.promocion.programa_id = '';
      }
    },
    async save() {
      await Axios.post('/promociones/actualizar', this.promocion).then(resp => {
        toastr["success"]('Registro Actualizado');
        $('#editar_promocion_Modal').modal('hide');
        document.getElementById('r_search').click();
      }).catch(err => {
        toastr["error"](err);
      });
    },
    async load() {
      this.promocion = await Axios.get(`/promociones/${this.promocionId}`).then(resp => resp.data);
      this.aplica = this.promocion.programa_id ? 'programa' : 'nacademico';
      await this.changeInstitucion();
    }
  }
}
</script>

<style>

</style>
